import { useState } from "react";
import ActionSheet, { ActionSheetProps } from "../ActionSheet";

import AddressSheet from "../AddressSheet";
import RightsSheet from "../RightsSheet";
import { RoleType } from "@/constants/share";
import Avatar from "@/component/Avatar";
import { getSpeakerAvatarInfo } from "@/utils/newAvatar";
import { avatarBgs } from "@/constants/record";
import { MeetingSharesItem } from "@/types/share";
import userInfoStore from "@/store/user.store";
import { showDialog } from "@/component/Dialog";


function SharerMemberSheet(
  props: Pick<ActionSheetProps, "onClose"> & {
    visible: boolean;
    addressVisible: boolean;
    shareId?: string;
    mySharePermission: RoleType;
    shareList: MeetingSharesItem[];
    removeShareMember: (sharer: MeetingSharesItem) => void;
    updateShareMenber: (sharer: MeetingSharesItem) => void;
    inviteMember: (sharers: MeetingSharesItem[]) => Promise<boolean>;
  }
) {

  const company = userInfoStore((state) => state.company);

  const { addressVisible, shareId, mySharePermission, shareList, removeShareMember, updateShareMenber, inviteMember } = props;
  const [showAddress, setShowAddress] = useState(false);


  const handleRightsChange = (value: MeetingSharesItem) => {
    console.log('操作共享人=', value.sharePermission);
    if (value.sharePermission === RoleType.Removed) {
      handleDelete(value);
    } else {
      handleChangeUserRights(value);
    }
  };

  const handleDelete = async (value: MeetingSharesItem) => {
    await showDialog({
      title: `确认移除${value.name}吗？`,
      content: "移除后该共享人将无法再查看这篇会记",
      confirmText: "移除",
      cancelText: "取消",
    });
    removeShareMember(value);
  };

  const handleChangeUserRights = (value: MeetingSharesItem) => {
    updateShareMenber(value);
  };

  const handleAddedSharers = async (addedUsers: MeetingSharesItem[]) => {
    const res = await inviteMember(addedUsers);
    res && setShowAddress(false);
  };

  return (
    <>
      <ActionSheet
        {...props}
        title="共享人"
        fullScreen={true}
        showReturn={true}
        className="bg-#F4F6F9!"
        contentClassName="p-6 overflow-auto"
      >
        {addressVisible &&
          <div
            className="h-10 w-full bg-mx-white rd-3 flex items-center justify-center text-size-3.5 line-height-3.5 color-mx-secondary mb-6"
            onClick={() => setShowAddress(true)}
          >从通讯录导入</div>
        }
        {shareList.map((user, index) => {
          const sharerAvatarInfo = getSpeakerAvatarInfo(user.avatar);
          return (
            <div
              key={user.identityId}
              className="h-12 flex items-center justify-between mb-2">
              <div className="flex items-center text-#30343C text-3.5">
                <Avatar
                  className="w-8 h-8 text-3 font-600"
                  userInfo={{
                    userId: user.identityId,
                    displayName: user.name,
                    avatarUrl: sharerAvatarInfo.avatarUrl,
                    avatarIndex: sharerAvatarInfo.avatarIndex || index % avatarBgs.length,
                  }}
                />
                <span className="m-l-4">{user.name}</span>
                {user.identityId === company?.identityId ? "（我）" : ""}
              </div>
              <RightsSheet user={user} onChange={handleRightsChange}
                editable={user.sharePermission !== RoleType.Creator && (mySharePermission === RoleType.Manager || mySharePermission === RoleType.Creator) && user.identityId !== company?.identityId} // 当前item不是创建人，并且我是创建人或管理者，并且不是本人
              />
            </div>
          );
        }
        )}
      </ActionSheet>
      <AddressSheet
        visible={showAddress}
        shareId={shareId ?? ""}
        onClose={() => setShowAddress(false)}
        onAdded={handleAddedSharers}
        mySharePermission={mySharePermission} />
    </>
  );
}
export default SharerMemberSheet;
